function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { TabElement, TabImage, TitleElement } from './elements';
import { Icon } from '../Icon';
import { StateLayer } from '../../core-components';
export const Tab = /*#__PURE__*/React.forwardRef(({
  title,
  iconSrc,
  isActive,
  size,
  iconPosition,
  tabWidth,
  imageSrc,
  imageAlt,
  ...rest
}, fRef) => {
  const iconSize = (iconPosition === 'center' ? {
    medium: 'xlarge',
    small: 'large'
  } : {
    medium: 'large',
    small: 'normal'
  })[size];
  if (iconSrc && (imageSrc || imageAlt)) {
    console.warn('Tab component should not have both iconSrc and imageSrc/imageAlt props');
  }
  if (imageSrc && !imageAlt) {
    console.warn('Tab component should have imageAlt prop when imageSrc is provided');
  }
  return /*#__PURE__*/React.createElement(TabElement, _extends({
    role: "tab",
    tabIndex: isActive ? 0 : -1,
    "aria-selected": isActive,
    "aria-label": title,
    ref: fRef,
    $isActive: isActive,
    $size: size,
    $iconPosition: iconPosition,
    $tabWidth: tabWidth
  }, rest), /*#__PURE__*/React.createElement(StateLayer, null), iconSrc && !imageSrc && /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: iconSize,
    fill: 'currentColor'
  }), imageSrc && !iconSrc && /*#__PURE__*/React.createElement(TabImage, {
    src: imageSrc,
    alt: imageAlt
  }), /*#__PURE__*/React.createElement(TitleElement, {
    iconPosition: iconPosition
  }, title));
});